export type EventBusCallback = (...args: Array<any>) => void;

const subscriptions: Record<string, Set<EventBusCallback>> = {};

const subscribe = (eventName: string, callback: EventBusCallback) => {
  if (!subscriptions[eventName]) {
    subscriptions[eventName] = new Set();
  }

  const callbacks = subscriptions[eventName];
  callbacks.add(callback);

  return () => {
    callbacks.delete(callback);

    if (callbacks.size === 0) {
      delete subscriptions[eventName];
    }
  };
};

const broadcast = (eventName: string, ...args: any[]) => {
  if (!subscriptions[eventName]) {
    return;
  }

  const callbacks = subscriptions[eventName];

  callbacks.forEach((callback) => {
    callback(...args);
  });
};

export default {
  subscribe,
  broadcast,
};
